import PWDService from './apiClient';
import FieldActivityClosureStatus from './FieldActivityClosureStatus';

async function dynamicsWorker(fieldActivity) {
    console.log("running dynamicsWorker for faId: ", fieldActivity.FieldActivityId);

    switch(fieldActivity.DynamicsClosureStatus) {
        case FieldActivityClosureStatus.REPAIRED:
        case FieldActivityClosureStatus.REPLACED:
        case FieldActivityClosureStatus.REMOVED:
        case FieldActivityClosureStatus.DELIVERED:

            return PWDService.closeDynamicsEntity(fieldActivity.ServiceRequestNumber, "RESOLVED", fieldActivity.FieldActivityId, fieldActivity.MainPersonId, fieldActivity.DynamicsClosureStatus);

        case FieldActivityClosureStatus.CONTAINER_NOT_OUT:

            //default to NA to keep Flow process from failing if provided a null
            let photoId = 'NA';

            if (fieldActivity.ServiceRequestNumber) {
                //if we also have a photo item id from sharepint
                if (fieldActivity.SharePointPhotoId) {
                    photoId = fieldActivity.SharePointPhotoId;
                }
                return PWDService.updateCnoInCrm(fieldActivity.ServiceRequestNumber, fieldActivity.FieldActivityId, fieldActivity.MainPersonId, photoId);
            } else {
                return PWDService.updateCnoForCcb(fieldActivity.FieldActivityId, fieldActivity.MainPersonId);
            };

        case FieldActivityClosureStatus.FOREMAN_INVESTIGATE:

            let srNum = '';
            if (fieldActivity.ServiceRequestNumber){
                srNum = fieldActivity.ServiceRequestNumber;
            }

            return PWDService.foremanInvestigate(srNum, fieldActivity.FieldActivityId, fieldActivity.CompletedBy, fieldActivity.DynamicsClosureStatus);

        default:
            console.log("in default switch case of CcbWorker");
            return false;
    }

}

export { dynamicsWorker };